import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'https://pawtection-client-8ec67a7efb6d.herokuapp.com/api/';

interface QuestionConfig {
  id: string;
  question: string;
  type: string;
  options: string[];
  required: boolean;
  order: number;
  show: boolean;
  group: string;
}

interface QuestionGroup {
  key: string;
  label: string;
  order: number;
}

interface UnitExclusion {
  unit: string;
  building: string;
  isExcluded: boolean;
  reason: string;
  excludedAt: string;
  excludedBy: string;
}

interface PropertySettings {
  property_id: string;
  property_name: string;
  questionnaire: QuestionConfig[];
  questionGroups: QuestionGroup[];
  general: {
    maxPetsPerUnit: number;
    requireInsurance: boolean;
    requireVaccination: boolean;
    esaExemptFromFees: boolean;
    petTypeRestrictions: string[];
    weightLimit: number;
    breedRestrictions: string[];
  };
  notifications: Record<string, any>;
  unitExclusions?: UnitExclusion[];
}

export const settingsService = {
  async getPropertySettings(propertyId: string): Promise<PropertySettings> {
    try {
      // Fetch settings from properties.extra_data (JSONB) via backend
      const url = `${API_URL}admin/settings/${propertyId}`;
      console.log('🌐 Fetching questionnaire settings from:', url);
      console.log('📋 This reads from properties.extra_data (JSONB) in PostgreSQL');

      const response = await axios.get(url);
      console.log('✅ Settings loaded from database:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching property settings from database:', error);
      throw error;
    }
  }
};